import IApiCommand from '@/api/IApiCommand';
import { log, LoggingType } from '@/logging/CustomLogging';
import DisplayItem from '@/models/DisplayItem';
import Item from '@/models/Item';
import Section from '@/models/Section';
import IPersistenceCommandCreator from '../persistence/IPersistenceCommandCreator';
import StateController from '../state/StateController';
import TestController from '../TestController';
import ResponseApiController from './api/ResponseApiController';
import IResponse from './models/IResponse';
import IResponseSave from './models/IResponseSave';
import ResponseSendingAdjustment from './ResponseSendingAdjustment';

class ResponseController implements IPersistenceCommandCreator<IResponseSave> {
  private readonly responseApiController: ResponseApiController;
  private readonly testController: TestController;
  private readonly responseSendingAdjustment = new ResponseSendingAdjustment();

  constructor(testController: TestController) {
    this.testController = testController;

    this.responseApiController = new ResponseApiController(testController!.baseServiceUrl);
  }

  //IPersistenceCommandCreator
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getCommand(item: DisplayItem | undefined | null, ignoreSessionData: boolean): IApiCommand<IResponseSave> | null {
    if (item && item instanceof Item && item.state) {
      const responseData: IResponseSave = {
        qti_session_id: this.testController.sessionController!.sessionData!.id!,
        client_id: this.testController.sessionController!.sessionData!.client_id,
        qti_item_reference: item.identifier,
        response: StateController.adjustState(JSON.parse(item.state), this.responseSendingAdjustment),
      };
      return this.responseApiController.createPersistenceCommand(responseData);
    } else {
      return null;
    }
  }

  populateTestItems(): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    return new Promise<void>((resolve, reject) => {
      that.responseApiController
        .getResponses<IResponse>(that.testController.sessionController!.sessionData!.id!)
        .then((responseData) => {
          if (responseData && responseData.qti_session_id === that.testController.sessionController!.sessionData!.id!) {
            if (responseData.items && responseData.items.length > 0) {
              responseData.items.forEach((item) => {
                if (item && item.response) {
                  const testItem: Item | null = that.findItem(item.item_identifier);
                  if (testItem) {
                    testItem.state = JSON.stringify(
                      Object.assign(
                        {},
                        JSON.parse(testItem.state ? testItem.state : '{}'),
                        StateController.adjustState(item.response, that.responseSendingAdjustment)
                      )
                    );
                  }
                }
              });
            }
          }

          resolve();
        })
        .catch((error) => reject(error));
    });
  }

  private findItem(itemIdentifier: string): Item | null {
    const items: Array<Item> = new Array<Item>();
    this.testController.test?.testParts.forEach((testPart) => {
      testPart.sections.forEach((section) => {
        this.findSectionItems(section, itemIdentifier, items);
      });
    });

    if (items.length > 1) {
      log('ResponseController.findItem: Multiple items found matching: ' + itemIdentifier, LoggingType.ERROR);
      return null;
    }
    if (items.length === 0) {
      log('ResponseController.findItem: No item found matching: ' + itemIdentifier, LoggingType.ERROR);
      return null;
    }

    return items[0];
  }

  private findSectionItems(section: Section, itemIdentifier: string, items: Array<Item>): void {
    if (section.subSections && section.subSections.length > 0) {
      section.subSections.forEach((subSection) => {
        this.findSectionItems(subSection, itemIdentifier, items);
      });
    }

    section.items.forEach((item) => {
      if (item.identifier === itemIdentifier) {
        items.push(item);
      }
    });
  }
}

export default ResponseController;
